<template>
  <div class="source">
    <button
      v-for="(sc, index) in sourceConfig.sources"
      class="source__button"
      @click="sourceClick(sc.key)"
      :key="index"
      :class="{ selected: source === sc.key }"
    >
      {{ sc.name.toUpperCase() }}
    </button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "FilterSource",
  computed: {
    sources() {
      return this.sourceConfig.sources;
    },

    ...mapGetters({
      source: "ui/source",
      sourceConfig: "ui/currentSourceConfig",
    }),
  },

  methods: {
    sourceClick(key) {
      this.setSource(key);
      this.calcData();
    },
    ...mapActions({
      setSource: "ui/setSource",
      calcData: "data/calcData",
    }),
  },
};
</script>

<style lang="scss" scoped>
.source {
  height: 100%;
  width: 100%;
  display: flex;

  &__button {
    @include filter-button;
  }
}

.mobile,
.tablet {
  .source {
    overflow-x: auto;
    &__button {
      height: toRem(48);
      margin: 0 toRem(15);
      white-space: nowrap;
    }
  }
}
</style>